import BaseModal from 'app/views/modals/base_modal';
import ObjectDetailsView from 'app/components/list/object_details';

import tmpl from './template';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  initialize({ showDetails, title = this.model.get('id') }) {
    this.title = title;

    this.addSubview(
      'details',
      '.shipment-details',
      new ObjectDetailsView({ showDetails, model: this.model }),
    );
  },

  context() {
    return {
      ...this.model.rawJSON,
      title: this.title,
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/shipments/detail_modal/index.js